import { useState } from "react";

import { MuiButton } from "@/components/ui/mui-button";
import { MuiTypography } from "@/components/ui/mui-typography";
import { RequestItemDialog, type RequestItemSuccess } from "./request-item-dialog";

// The Item Search island's Request Item band — the donor's `RequestAddItem`
// (`ItemSearchIsland/components/RequestAddItem.tsx`), under the results on every
// settled search, whatever its count: the band *is* the island's zero-result
// message (research `spec-editor-baseline-selections.md` §7).
//
// **Presentational, and it owns its dialog** the way `RequestItemButton` does:
// the open state is nobody else's business. What it does not own is the
// category — the donor resolves the URL's `?category` slug against its cache
// at click time, and the URL is the island host's (#811), so the host hands in
// the resolved id.
//
// **No permission gate**, unlike `RequestItemButton`: the donor draws the band
// for every viewer of the island, and only spec editors reach the island.
// Python's refusal, should a role there not be allowed to create, comes back
// through the dialog's own submit-error snackbar.

interface RequestAddItemProps {
  /** The category the island is filtered by, already resolved, or `null`. */
  categoryId: number | null;
  /** The dialog's success report, passed straight through. */
  onSuccess?: (result: RequestItemSuccess) => void;
}

export function RequestAddItem({ categoryId, onSuccess }: RequestAddItemProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* `Stack spacing={1} alignItems='center' sx={{ py: 3, bgcolor:
          '#F0F0F0', width: '100%' }}`. The ink is `text.primary`, which the
          donor's text inherits from `body` and this app's `body` does not
          carry. */}
      <div
        data-testid="request-add-item"
        className="bg-catalog-request-band text-lennar-ink flex w-full flex-col items-center gap-2 py-6"
      >
        <MuiTypography variant="h4">
          Can&apos;t find the item you&apos;re looking for?
        </MuiTypography>
        <MuiTypography variant="body2" className="pb-2">
          You can request for an item to be added to the catalog.
        </MuiTypography>
        {/* `variant='outlined' sx={{ padding: '8px 14px' }}` at the default
            medium size — the padding replaces MUI's own `5px 15px`. */}
        <MuiButton
          data-testid="request-item-button"
          variant="outlined"
          className="px-[14px] py-2"
          onClick={() => setOpen(true)}
        >
          Request Item
        </MuiButton>
      </div>
      <RequestItemDialog
        open={open}
        onOpenChange={setOpen}
        initialCategoryId={categoryId}
        onSuccess={onSuccess}
      />
    </>
  );
}
